import { initParams } from './initial-dataset';
import { getValidStore } from '../utils';

const { store, appId } = initParams;

const structure = {
  assets: {
    app_about: {
      assets: ['about_data', 'ratings', 'versions', 'other_data'],
      filters: { store: getValidStore(store) },
    },
  },
};

export const storeConfiguration = {
  structure,
  url: `/apps/${store}/${appId}/about_data.json`,
  httpMethod: 'get',
};
